export default __webpack_public_path__ + "static/media/134_Bubble-Brush_kawai0001.e376b465.png";